import React, { useEffect, useState } from 'react'
import Button1 from '../../../Button/Button1';
import ListOption from './ListOption';

import classes from "../CreateRule/SelectOutputs.module.css";
import Button2 from '../../../Button/Button2';

const SelectOutputs = ({ body, setBody, listItems, modalPageIndex, outputList, nextPage, isReminder, time }) => {

    //pass back selected outputs
    const [selectedOutputsInt, setSelectedOutputsInt] = useState([]);
    console.log(isReminder)

    const HandeOnClick = () => {

        const tempArray = selectedOutputsInt

        const selectedOutputsAsString = tempArray;

        if (selectedOutputsAsString.length != 0) {
            setBody(prevBody => ({ ...prevBody, pin: selectedOutputsAsString }));
        }
        // isReminder == 1 ? nextPage(1) : nextPage(2);
        nextPage(1);
    }

    const HandleOnItemClicked = (item) => {
        const doesItemAlreadyExitInArray = selectedOutputsInt.find(Pin => Pin == item.Pin);

        if (doesItemAlreadyExitInArray) {
            const outputPin = listItems.find(Pin => Pin.Pin == doesItemAlreadyExitInArray);
            removeItem(outputPin)
        } else {
            const outputPin = listItems.find(Pin => Pin.pinName == item.pinName);
            addItem(outputPin)
        }
    }

    const addItem = (item) => {
        // Create a copy of the current array
        const newArray = [...selectedOutputsInt];
        // Push the new item to the copy
        const pinAsString = String(item.Pin)
        newArray.push(pinAsString);

        // Set the state with the new array
        setSelectedOutputsInt(newArray);

    };

    const removeItem = (item) => {
        const newArray = [...selectedOutputsInt];
        const filterArray = newArray.filter((Pin, index) => String(Pin) != item.Pin);

        // Set the state with the new array
        setSelectedOutputsInt(filterArray);

    }

    //filter out unwanted outputs
    const FilterArray = (listItems) => {
        // return listItems.filter(item => item.Pin != body.input);
        // return listItems.filter(item => item.pinName !== body.input && item.type !== "PULSE");

        return listItems
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>

            <div style={{ position: "absolute", right: "40px", top: "60px" }}>
                <button className={classes.nextButton} disabled={selectedOutputsInt.length == 0} onClick={HandeOnClick}>
                    {">"}
                </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <h3 style={{ color:"#6e6e6e"}}>{`Which switch do you want the ${isReminder == 0 ? "schedule" : "reminder"} on?`}</h3>
                <br></br>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                            {FilterArray(listItems).map((item, index) => {
                                return (
                                    <Button2 key={index} onClick={() => HandleOnItemClicked(item)} style={{ minWidth: "300px", minHeight:"40px", backgroundColor: selectedOutputsInt.find(Pin => String(Pin) == item.Pin) && "var(--Primary-Color)", color: selectedOutputsInt.find(Pin => Pin == item.Pin) && "white", border: selectedOutputsInt.find(Pin => Pin == item.Pin) && "2px solid lightblue" }}>
                                        {item.pinName}
                                    </Button2>

                                )
                            })}
                        </ul >
                    
                </div>
            </div>

        </div >
    )
}

export default SelectOutputs